import React from "react";
import HomeProductCard from "./HomeProductCard";

const HomeProductGrid = ({ section, data, loading }) => {
    // Show loading state
    if (loading) {
        return (
            <div className="relative px-4 sm:px-6 lg:px-8 py-10 bg-white">
                <h2 className="text-3xl font-extrabold text-organic-charcoal text-center mb-10 uppercase tracking-wide">
                    {section}
                </h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                    {[...Array(4)].map((_, index) => (
                        <div key={index} className="animate-pulse bg-gray-200 h-64 rounded"></div>
                    ))}
                </div>
            </div>
        );
    }

    // Show message if no products
    if (!data || data.length === 0) {
        return (
            <div className="relative px-4 sm:px-6 lg:px-8 py-10 bg-white">
                <h2 className="text-3xl font-extrabold text-organic-charcoal text-center mb-10 uppercase tracking-wide">
                    {section}
                </h2>
                <div className="text-center text-gray-500 py-10">
                    <p>No products available</p>
                </div>
            </div>
        );
    }

    return (
        <div className="relative px-4 sm:px-6 lg:px-8 py-10 bg-white">
            <h2 className="text-3xl font-extrabold text-organic-charcoal text-center mb-10 uppercase tracking-wide">
                {section}
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {data?.slice(0, 8).map((item) => (
                    <HomeProductCard key={item.id} product={item} />
                ))}
            </div>
        </div>
    );
};

export default HomeProductGrid;
